// IMPLEMENTATION NOTE (not customer-facing):
// This is the static prototype data for the GunBroker Listings page.
// A live GunBroker/API feed will replace this array in final WebsiteForge setup.
// If imageUrl is empty or fails to load, the card falls back to a branded
// category placeholder.

export type GunBrokerListing = {
  itemNumber: string
  title: string
  manufacturer: string
  model: string
  category: 'Firearms' | 'Ammunition' | 'NFA / Suppressors'
  itemType: 'Rifle' | 'Shotgun' | 'Handgun' | 'Ammunition' | 'Suppressor'
  caliberGauge: string
  condition: 'New' | 'Used' | 'Not listed'
  listingType: 'Fixed Price' | 'Auction'
  priceLabel: string
  priceValue: number
  roundCount: string
  pricePerRound: string
  quantity: string
  shipping: string
  bids: string
  timeLeft: string
  imageUrl: string
  gunbrokerUrl: string
  tags: string[]
}

export const GUNBROKER_SELLER_URL =
  'https://www.gunbroker.com/All/search?IncludeSellers=312764'

export const gunbrokerListings: GunBrokerListing[] = [
  {
    itemNumber: '1170254453',
    title: 'Winchester 17WSM Varmint HV 20gr 500rd In Stock!',
    manufacturer: 'Winchester',
    model: '17WSM Varmint HV 20gr',
    category: 'Ammunition',
    itemType: 'Ammunition',
    caliberGauge: '17 WSM',
    condition: 'Not listed',
    listingType: 'Fixed Price',
    priceLabel: '$219.98',
    priceValue: 219.98,
    roundCount: '500 rounds',
    pricePerRound: '44¢ /rd',
    quantity: '7',
    shipping: '$15.00 shipping',
    bids: '',
    timeLeft: '',
    imageUrl:
      'https://assets.gunbroker.com/w_400,h_300,c_fit/q_auto:best/f_auto/pics/1170254000/1170254453/thumb.jpg',
    gunbrokerUrl: 'https://www.gunbroker.com/item/1170254453',
    tags: ['Ammunition', 'Winchester', '17 WSM', '500 rounds', 'Fixed Price'],
  },
  {
    itemNumber: '1180046231',
    title: 'Hornady 223 Rem 55GR SP 500 Rounds 80255',
    manufacturer: 'Hornady',
    model: '55GR SP 80255',
    category: 'Ammunition',
    itemType: 'Ammunition',
    caliberGauge: '223 Rem',
    condition: 'Not listed',
    listingType: 'Fixed Price',
    priceLabel: '$249.00',
    priceValue: 249.0,
    roundCount: '500 rounds',
    pricePerRound: '50¢ /rd',
    quantity: '10+',
    shipping: '$15.00 shipping',
    bids: '',
    timeLeft: '',
    imageUrl:
      'https://assets.gunbroker.com/w_400,h_300,c_fit/q_auto:best/f_auto/pics/1180046000/1180046231/pix146278265',
    gunbrokerUrl: 'https://www.gunbroker.com/item/1180046231',
    tags: ['Ammunition', 'Hornady', '223 Rem', '500 rounds', 'Fixed Price'],
  },
  {
    itemNumber: '1160361267',
    title: 'Browning 1911-22 A1 Black Label SR 22LR NEW 051820490 In Stock!',
    manufacturer: 'Browning',
    model: '1911-22 A1 Black Label SR',
    category: 'Firearms',
    itemType: 'Handgun',
    caliberGauge: '22 LR',
    condition: 'New',
    listingType: 'Fixed Price',
    priceLabel: '$779.99',
    priceValue: 779.99,
    roundCount: '',
    pricePerRound: '',
    quantity: '1',
    shipping: '$55.00 shipping',
    bids: '',
    timeLeft: '',
    imageUrl:
      'https://assets.gunbroker.com/w_400,h_300,c_fit/q_auto:best/f_auto/pics/1160361000/1160361267/thumb.jpg',
    gunbrokerUrl: 'https://www.gunbroker.com/item/1160361267',
    tags: ['Firearm', 'Handgun', 'Browning', '22 LR', 'New', 'Fixed Price'],
  },
  {
    itemNumber: '1160367442',
    title:
      'Browning Citori 725 Sporting Medallion High Grade 20ga 30" NEW In Stock!',
    manufacturer: 'Browning',
    model: 'Citori 725 Sporting Medallion High Grade',
    category: 'Firearms',
    itemType: 'Shotgun',
    caliberGauge: '20 gauge',
    condition: 'New',
    listingType: 'Fixed Price',
    priceLabel: '$6,119.98',
    priceValue: 6119.98,
    roundCount: '',
    pricePerRound: '',
    quantity: '1',
    shipping: '$95.00 shipping',
    bids: '',
    timeLeft: '',
    imageUrl:
      'https://assets.gunbroker.com/w_400,h_300,c_fit/q_auto:best/f_auto/pics/1160367000/1160367442/thumb.jpg',
    gunbrokerUrl: 'https://www.gunbroker.com/item/1160367442',
    tags: ['Firearm', 'Shotgun', 'Browning', '20 gauge', 'New', 'Fixed Price'],
  },
  {
    itemNumber: '1160367732',
    title: 'Browning BAR MK3 Stalker 308 Win NEW 031048218 In Stock!',
    manufacturer: 'Browning',
    model: 'BAR MK3 Stalker',
    category: 'Firearms',
    itemType: 'Rifle',
    caliberGauge: '308 Win',
    condition: 'New',
    listingType: 'Fixed Price',
    priceLabel: '$1,329.99',
    priceValue: 1329.99,
    roundCount: '',
    pricePerRound: '',
    quantity: '1',
    shipping: 'Free shipping available',
    bids: '',
    timeLeft: '',
    imageUrl:
      'https://assets.gunbroker.com/w_400,h_300,c_fit/q_auto:best/f_auto/pics/1160367000/1160367732/thumb.jpg',
    gunbrokerUrl: 'https://www.gunbroker.com/item/1160367732',
    tags: [
      'Firearm',
      'Rifle',
      'Browning',
      '308 Win',
      'New',
      'Fixed Price',
      'Free Shipping',
    ],
  },
  {
    itemNumber: '1160386363',
    title: 'Savage 93R17 FVSS 17 HMR NEW 96703 In Stock!',
    manufacturer: 'Savage',
    model: '93R17 FVSS',
    category: 'Firearms',
    itemType: 'Rifle',
    caliberGauge: '17 HMR',
    condition: 'New',
    listingType: 'Fixed Price',
    priceLabel: '$349.98',
    priceValue: 349.98,
    roundCount: '',
    pricePerRound: '',
    quantity: '1',
    shipping: '$30.00 shipping',
    bids: '',
    timeLeft: '',
    imageUrl:
      'https://assets.gunbroker.com/w_400,h_300,c_fit/q_auto:best/f_auto/pics/1160386000/1160386363/thumb.jpg',
    gunbrokerUrl: 'https://www.gunbroker.com/item/1160386363',
    tags: ['Firearm', 'Rifle', 'Savage', '17 HMR', 'New', 'Fixed Price'],
  },
  {
    itemNumber: '1160557145',
    title: 'Weatherby 224 Wby Mag 55gr SP 20rd In Stock!',
    manufacturer: 'Weatherby',
    model: '224 Wby Mag 55gr SP',
    category: 'Ammunition',
    itemType: 'Ammunition',
    caliberGauge: '224 Wby Mag',
    condition: 'Not listed',
    listingType: 'Fixed Price',
    priceLabel: '$86.98',
    priceValue: 86.98,
    roundCount: '20 rounds',
    pricePerRound: '$4.35 /rd',
    quantity: '10+',
    shipping: '$15.00 shipping',
    bids: '',
    timeLeft: '',
    imageUrl:
      'https://assets.gunbroker.com/w_400,h_300,c_fit/q_auto:best/f_auto/pics/1160557000/1160557145/thumb.jpg',
    gunbrokerUrl: 'https://www.gunbroker.com/item/1160557145',
    tags: [
      'Ammunition',
      'Weatherby',
      '224 Wby Mag',
      '20 rounds',
      'Fixed Price',
    ],
  },
  {
    itemNumber: '1160608819',
    title: 'Silencerco Hybrid 46M NEW SU5107 In Stock!',
    manufacturer: 'SilencerCo',
    model: 'Hybrid 46M',
    category: 'NFA / Suppressors',
    itemType: 'Suppressor',
    caliberGauge: 'Multi-caliber / 46M',
    condition: 'New',
    listingType: 'Fixed Price',
    priceLabel: '$993.65',
    priceValue: 993.65,
    roundCount: '',
    pricePerRound: '',
    quantity: '1',
    shipping: '$35.00 shipping',
    bids: '',
    timeLeft: '',
    imageUrl:
      'https://assets.gunbroker.com/w_400,h_300,c_fit/q_auto:best/f_auto/pics/1160608000/1160608819/thumb.jpg',
    gunbrokerUrl: 'https://www.gunbroker.com/item/1160608819',
    tags: [
      'NFA',
      'Suppressor',
      'SilencerCo',
      'Hybrid 46M',
      'New',
      'Fixed Price',
    ],
  },
  {
    itemNumber: '1164849520',
    title: 'Savage Axis 6.5 Creedmoor USED In Stock!',
    manufacturer: 'Savage',
    model: 'Axis',
    category: 'Firearms',
    itemType: 'Rifle',
    caliberGauge: '6.5 Creedmoor',
    condition: 'Used',
    listingType: 'Auction',
    priceLabel: 'Starting Bid $329.98',
    priceValue: 329.98,
    roundCount: '',
    pricePerRound: '',
    quantity: '',
    shipping: '$30.00 shipping',
    bids: '0',
    timeLeft: '1d 20h',
    imageUrl:
      'https://assets.gunbroker.com/w_400,h_300,c_fit/q_auto:best/f_auto/pics/1164849000/1164849520/pix519258375',
    gunbrokerUrl: 'https://www.gunbroker.com/item/1164849520',
    tags: ['Firearm', 'Rifle', 'Savage', '6.5 Creedmoor', 'Used', 'Auction'],
  },
  {
    itemNumber: '1164850313',
    title: 'Mossberg 500 12ga 28" USED In Stock!',
    manufacturer: 'Mossberg',
    model: '500',
    category: 'Firearms',
    itemType: 'Shotgun',
    caliberGauge: '12 gauge',
    condition: 'Used',
    listingType: 'Auction',
    priceLabel: 'Starting Bid $239.98',
    priceValue: 239.98,
    roundCount: '',
    pricePerRound: '',
    quantity: '',
    shipping: '$30.00 shipping',
    bids: '0',
    timeLeft: '1d 20h',
    imageUrl:
      'https://assets.gunbroker.com/w_400,h_300,c_fit/q_auto:best/f_auto/pics/1164850000/1164850313/pix782434779',
    gunbrokerUrl: 'https://www.gunbroker.com/item/1164850313',
    tags: ['Firearm', 'Shotgun', 'Mossberg', '12 gauge', 'Used', 'Auction'],
  },
  {
    itemNumber: '1164851485',
    title: 'Weatherby Element 12ga 28" USED In Stock!',
    manufacturer: 'Weatherby',
    model: 'Element',
    category: 'Firearms',
    itemType: 'Shotgun',
    caliberGauge: '12 gauge',
    condition: 'Used',
    listingType: 'Auction',
    priceLabel: 'Starting Bid $569.98',
    priceValue: 569.98,
    roundCount: '',
    pricePerRound: '',
    quantity: '',
    shipping: '$30.00 shipping',
    bids: '0',
    timeLeft: '1d 21h',
    imageUrl:
      'https://assets.gunbroker.com/w_400,h_300,c_fit/q_auto:best/f_auto/pics/1164851000/1164851485/pix301363404',
    gunbrokerUrl: 'https://www.gunbroker.com/item/1164851485',
    tags: ['Firearm', 'Shotgun', 'Weatherby', '12 gauge', 'Used', 'Auction'],
  },
  {
    itemNumber: '1160622880',
    title: 'Barrett M107A1-S 50BMG NEW 18062-S In Stock!',
    manufacturer: 'Barrett',
    model: 'M107A1-S',
    category: 'Firearms',
    itemType: 'Rifle',
    caliberGauge: '50 BMG',
    condition: 'New',
    listingType: 'Fixed Price',
    priceLabel: '$12,867.00',
    priceValue: 12867.0,
    roundCount: '',
    pricePerRound: '',
    quantity: '1',
    shipping: '$100.00 shipping',
    bids: '',
    timeLeft: '',
    imageUrl:
      'https://assets.gunbroker.com/w_400,h_300,c_fit/q_auto:best/f_auto/pics/1160622000/1160622880/thumb.jpg',
    gunbrokerUrl: 'https://www.gunbroker.com/item/1160622880',
    tags: ['Firearm', 'Rifle', 'Barrett', '50 BMG', 'New', 'Fixed Price'],
  },
]
